import { Table, TableBody, TableCell, TableRow } from '@mui/material';
import { typography } from '@mui/system';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useAppSelector } from 'features/app/hooks';
import { callSelector } from 'features/call/call-base/store/selectors';
import { getGenderText } from 'features/collaboration-base/helpers';
import { getTeamingReasonText } from 'features/teaming/teaming-base/helpers';
import {
  isHandoffSelector,
  isInPersonTeamingSelector,
  teamingReasonSelector,
  teamingStationSelector,
} from 'features/teaming/teaming-base/store';
import styled from 'features/theme/styled';
import theme from 'features/theme/theme';

export const TeamingInfo: FC = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'teamingInfo' });
  const reason = useAppSelector(teamingReasonSelector);
  const isHandoffReason = useAppSelector(isHandoffSelector);
  const isInPersonTeaming = useAppSelector(isInPersonTeamingSelector);
  const station = useAppSelector(teamingStationSelector);
  const { languageCode, genderRequest } = useAppSelector(callSelector);

  return (
    <Table>
      <TableBody>
        {!isHandoffReason && (
          <StyledTableRow key='reason'>
            <Title component='th' scope='row'>
              {t('reason')}
            </Title>
            <Value align='left'>{getTeamingReasonText(reason)}</Value>
          </StyledTableRow>
        )}
        <StyledTableRow key='language'>
          <Title component='th' scope='row'>
            {t('language')}
          </Title>
          <Value align='left'>{languageCode}</Value>
        </StyledTableRow>
        <StyledTableRow key='gender'>
          <Title component='th' scope='row'>
            {t('gender')}
          </Title>
          <Value align='left'>{getGenderText(genderRequest!)}</Value>
        </StyledTableRow>
        {isInPersonTeaming && (
          <StyledTableRow key='location'>
            <Title component='th' scope='row'>
              {t('location')}
            </Title>
            <Value align='left'>{`${t('inCenter')}; ${t(
              'station'
            )} ${station}`}</Value>
          </StyledTableRow>
        )}
      </TableBody>
    </Table>
  );
};

const Title = styled(TableCell)`
  width: 110px;
  padding: ${theme.spacing(3)} 0;
  ${typography(theme.typography.textLargeMedium)};
  color: ${theme.palette.grey[50]};
  border-bottom: 1px solid ${theme.palette.grey[600]};
`;

const Value = styled(TableCell)`
  padding: ${theme.spacing(3)} 0;
  ${typography(theme.typography.body1)};
  color: ${theme.palette.grey[50]};
  border-bottom: 1px solid ${theme.palette.grey[600]};
`;

const StyledTableRow = styled(TableRow)`
  ${typography(theme.typography.body1)};
  color: ${theme.palette.grey[50]};
  &:last-child td,
  &:last-child th {
    border: 0;
  }
`;
